import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import AssociarError from '../../../assets/associar-error.svg';
import AssociarFuncionario from '../../../assets/associar-funcionario.svg';
import {
  AssociacaoFuncionario,
  associacaoFuncionarioFormModelSchema
} from '../../../models/AssociacaoFuncionario.model';
import FuncionarioService from '../../../services/Funcionario.service';
import { Colors } from '../../../shared/colors';
import FeedbackDrawer from '../../components/FeedbackDrawer';
import Loading from '../../components/Loading';

import FormCartao from './FormCartao';

interface Props {
  onClose: () => void;
  associacaoFuncionario: AssociacaoFuncionario;
}

const FormAssociarCartao = ({ onClose, associacaoFuncionario }: Props) => {
  const [errorMSg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const form = useForm<AssociacaoFuncionario>({
    defaultValues: associacaoFuncionario,
    resolver: yupResolver(associacaoFuncionarioFormModelSchema)
  });

  const associarCartao = (data: AssociacaoFuncionario) => {
    FuncionarioService.associarCartao(data)
      .then(() => setCompleted(true))
      .catch((err) => {
        setErrorMsg(err.message);
      })
      .finally(() => setLoading(false));
  };
  if (completed)
    return (
      <FeedbackDrawer
        titulo="Cartão associado!"
        subtitulo="Cartão associado com sucesso!"
        textoBotao="Fechar"
        onClick={onClose}
        imagemModal={AssociarFuncionario}
      />
    );

  if (errorMSg)
    return (
      <FeedbackDrawer
        titulo="Erro ao associar!"
        subtitulo={errorMSg}
        textoBotao="Fechar"
        onClick={onClose}
        imagemModal={AssociarError}
      />
    );

  return (
    <FormProvider {...form}>
      <Loading fullscreen show={loading} />
      <Box display="flex" flexDirection="column" alignItems="space-between" width={1}>
        <Box p={2}>
          <Typography color={Colors.secondary} variant="h6" mb={2}>
            Associar um cartão?
          </Typography>
          <FormCartao />
        </Box>
        <Grid container item xs={12} p={3} alignContent="flex-end">
          <Button fullWidth variant="contained" onClick={form.handleSubmit(associarCartao)}>
            <Typography variant="body1" textTransform="none">
              Confirmar associação
            </Typography>
          </Button>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default FormAssociarCartao;
